/* /shop-by-category (core webshop's own hub page, unthemed Bootstrap by
 * default - see rfhq_templates.css's category-card rules) sits outside any
 * [data-rfhq-theme] scope, same root cause already diagnosed and fixed for
 * the old #product-filters sidebar: RFHQ's --rfhq-* custom properties only
 * exist inside a themed ancestor, never globally, so every
 * var(--rfhq-section-bg, ...)-style rule targeting .shop-by-category-content
 * was silently rendering its literal fallback only. Same fix: claim it
 * data-rfhq-owned and hand it to the existing site-theme fallback.
 */

frappe.ready(function () {
	var el = document.querySelector('.shop-by-category-content');
	if (!el) return; // not this page

	el.setAttribute('data-rfhq-owned', '1');
	if (window.rfhqApplyOwnedThemeFallback) window.rfhqApplyOwnedThemeFallback(el);
});
